import { JobResponse } from '@doda/api-client/aspida/@types';
import { TAB_STATE } from '../../constants/jobSearchDetailTab';
import { SURASHU_N } from '../../constants/seo';

/**
 * 記事要約リストを文字列にして生成
 * @param {JobResponse} job
 * @param tabState
 * @returns corporateName
 */
export const makeArticleSummary = (job: JobResponse, tabState?: string) => {
  if (job.wcnsId === 'E' && tabState === TAB_STATE.pr) {
    // E原稿の場合かつPick Up!タブの場合求人要約を全部追加する
    if (job.articleSummaryList)
      return job.articleSummaryList?.join(SURASHU_N).concat(SURASHU_N);
  }
  return '';
};
